import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Subscriptions } from './components/subscriptions';
export function Webhooks({ section }) {
    return _jsx(_Fragment, { children: section || _jsx(Subscriptions, {}) });
}
